import React from "react"
import {
    View, Text, Image, StyleSheet, TouchableOpacity,
    Pressable
} from "react-native"
import * as CommonUtils from "../services/CommonUtils"
import AppStyles from "../../AppStyles"
import AppTheme from "../../AppTheme"
import { Avatar } from 'react-native-elements';
import { getCommonDateTime, getConsultationCallTime } from "../services/DateTimeUtils"
import { MaterialIcons } from '@expo/vector-icons';
import { store } from "../../store/store"
import { ScreenRoute } from "../constants/ScreenRouteConstant"
import { updateSelectedAayucard } from "../services/redux/commonRedux"
import { activtyDataSubscription } from "../services/subject-behaviour/CommonRxjsService"
import { CommonRightChevronIcon } from "./Common-Widget"
import TextStyle from "../../TextStyle"
import { ActivityType } from "../constants/AppConstants"
import Colors from "../constants/AppColors"
import { checkConsultationType } from "../services/econsult/EConsultUtils"

function makeEConsultPayment(props, consultationData) {
    updateSelectedAayucard({});
    const params = {
        memberId: consultationData.userId,
        memberName: consultationData.userName,
        consultationId: consultationData.id,
        caseCode: consultationData.category,
        category: consultationData.categoryRM.en,
        consultationHashcode: consultationData.wauHashCode,
        phoneNumber: CommonUtils.checkAlternatePhNumber(consultationData.userAlternateCallingNumber,
            consultationData.userPhoneNumber)
    };
    const reduxState = store.getState();
    const aayuValidity = CommonUtils.checkAayuSubscriptionValidity(
        reduxState.subscriptionData);
    props.navigation.navigate(aayuValidity.paymentRoute, {
        serviceParams: params, serviceName: 'Remote Consultation'
    })
}

function viewEconsultDetails(props, consultationData) {
    props.navigation.navigate(ScreenRoute.econsult_details,
        { consultationId: consultationData.id })
}

function handleOnPress(props, activityData, { isActivityList = true }) {
    if (activityData['acType'] == ActivityType.order) {
        props.navigation.replace(ScreenRoute.orders)
        if (isActivityList) props.navigation.pop()
    } else if (activityData['acType'] == ActivityType.consultation) {
        if (activityData['status'] == 'Payment pending')
            makeEConsultPayment(props, activityData)
        else viewEconsultDetails(props, activityData)
    }
}

function openMessageView(props, orderDetails) {
    props.navigation.navigate(ScreenRoute.oms_message_view,
        { orderData: orderDetails })
}


export const ActivityViewDesign = (props) => {
    const activityData = props.activityData
    return <TouchableOpacity onPress={() => { handleOnPress(props, activityData, { isActivityList: true }) }}>
        {activityData && activityData['acType'] == ActivityType.consultation ?
            <View style={[AppStyles.mediumShadow, {
                marginHorizontal: 16, marginTop: 16, paddingHorizontal: 16,
                borderRadius: 12, backgroundColor: 'white', height: 122
            }]}>
                <View style={[AppStyles.flexRowSpaceBetween, { marginTop: 16, marginBottom: 8 }]}>
                    <Text style={[TextStyle.text14b,
                    { color: Colors.black }]}>
                        {activityData['userName']}</Text>
                    <Text style={[TextStyle.text12xb, { color: Colors.primary }]}>
                        {checkConsultationType(activityData['serviceName'])}</Text></View>

                <Text style={[TextStyle.text14, { color: Colors.purple.text }]}>
                    {activityData['categoryRM']['en']}</Text>

                {
                    activityData['status'] == 'Ongoing' ? <View>

                        <View style={{ height: 1, backgroundColor: Colors.grey.divider, marginTop: 14, marginBottom: 16 }} />

                        <Text style={[TextStyle.text14, { textAlign: "center", marginBottom: 16 }]}>
                            {activityData['title']} <Text style={TextStyle.text14xb}>
                                {getConsultationCallTime(activityData['callExpectedBy'])}</Text></Text>

                    </View> : activityData['status'] == 'Consulted' ? <View>
                        <Pressable onPress={() => { CommonUtils.downloadPrescription(activityData['id'], activityData['serviceName']) }}
                            style={{
                                backgroundColor: Colors.primary, paddingVertical: 8, borderRadius: 20,
                                marginTop: 16, marginBottom: 16, alignItems: "center"
                            }}><Text style={[TextStyle.text12xb, {
                                color: activityData['statusColor']
                            }]}>{activityData['title']}</Text>

                        </Pressable>
                    </View> : <View>

                        <View style={{ height: 1, backgroundColor: Colors.grey.divider, marginTop: 14, marginBottom: 16 }} />

                        <View style={[AppStyles.flexRowSpaceBetween, { marginBottom: 16 }]}>
                            <Text style={[TextStyle.text14xb, { color: activityData['statusColor'] }]}>
                                {activityData['title']}</Text>
                            {CommonRightChevronIcon('black')}
                        </View>

                    </View>
                }
            </View> : activityData &&
                activityData['acType'] == ActivityType.order &&
                activityData['isActiveOrder'] ?
                <View style={[AppStyles.mediumShadow, {
                    marginHorizontal: 16, marginTop: 16,
                    borderRadius: 12, backgroundColor: 'white'
                }]}>
                    <View style={[AppStyles.flexRowStart,
                    { paddingHorizontal: 16, paddingTop: 12 }]}>
                        <Image source={{
                            uri: CommonUtils.getImagePath(activityData['statusIcon'] ?? ''),
                            width: 32, height: 32
                        }} />
                        <Text style={[TextStyle.text14b,
                        {
                            color: activityData['statusColor'],
                            marginLeft: 12
                        }]}>
                            {activityData['title']}</Text>
                    </View>

                    <View style={{
                        height: 1,
                        backgroundColor: Colors.grey.divider,
                        marginTop: 11, marginBottom: 12,
                        marginHorizontal: 16
                    }} />

                    <View style={[AppStyles.flexRowSpaceBetween, { paddingLeft: 16 }]}>

                        <View style={{ alignItems: "flex-start", marginBottom: 14 }}>
                            <Text style={[TextStyle.text14b,
                            { color: Colors.black }]}>
                                Order #{activityData['oid']}</Text>

                            <Text style={[TextStyle.text12, { color: Colors.grey.dateTime, marginTop: 8 }]}>
                                {getCommonDateTime(activityData['ts'])}</Text>
                        </View>

                        {activityData['pharmacyData']['unreadMsgCount'] ?
                            <Pressable onPress={() => { props.navigation.navigate(ScreenRoute.oms_message_view, { orderData: activityData }) }}
                                style={[AppStyles.flexRow, {
                                    paddingHorizontal: 14, paddingTop: 12, paddingBottom: 10, backgroundColor: Colors.blue.cta,
                                    borderTopLeftRadius: 12, borderBottomRightRadius: 12, alignSelf: "flex-end"
                                }]}>

                                <Text style={[TextStyle.text14xb, { color: 'white', marginRight: 6 }]}>
                                    {activityData['pharmacyData']['unreadMsgCount']} Message{activityData['pharmacyData']['unreadMsgCount'] == 1 ? '' : 's'}</Text>
                                {CommonRightChevronIcon('white')}

                            </Pressable> :
                            <View style={[AppStyles.flexRow, {
                                paddingHorizontal: 14, paddingTop: 12, paddingBottom: 10, backgroundColor: '#ECF1F8',
                                borderTopLeftRadius: 12, borderBottomRightRadius: 12, alignSelf: "flex-end"
                            }]}>

                                <Text style={[TextStyle.text14xb, { color: Colors.blue.cta, marginRight: 6 }]}>
                                    Track Order</Text>
                                {CommonRightChevronIcon('blue')}

                            </View>}

                    </View>

                </View> : <View />
        }
    </TouchableOpacity>
}

export const DashboardActivityViewDesign = (props) => {
    // const activityData = getActivityData(props.data)
    const activityData = props.activityData;
    const activityListData = props.activityList?.filter((item) => ((item['acType'] == ActivityType.consultation) ||
        (item['acType'] == ActivityType.order && item['isActiveOrder'])));
    return <TouchableOpacity onPress={() => { handleOnPress(props, activityData, { isActivityList: false }) }}
        key={activityData['acType'] == ActivityType.order ? activityData['oid'] : activityData['id']}>
        {
            activityData['acType'] == ActivityType.consultation ?
                <View style={[AppStyles.mediumShadow, {
                    marginRight: 8, marginTop: 16,
                    paddingHorizontal: 16,
                    borderRadius: 12, backgroundColor: 'white',
                    width: activityListData?.length === 1 ?
                        AppTheme.appWidth - 32 : 305,
                    height: 122
                }]}>
                    <View style={[AppStyles.flexRowSpaceBetween,
                    { marginTop: 16, marginBottom: 8 }]}>
                        <Text numberOfLines={1}
                            style={[TextStyle.text14b,
                            {
                                color: Colors.black,
                                width: activityListData?.length === 1 ?
                                    AppTheme.appWidth - 150 : 205
                            }]}>
                            {activityData['userName']}</Text>
                        <Text style={[TextStyle.text12xb,
                        { color: Colors.primary }]}>
                            {checkConsultationType(activityData['serviceName'])}
                        </Text>
                    </View>

                    <Text style={[TextStyle.text14,
                    { color: Colors.purple.text }]}>
                        {activityData['categoryRM']['en']}
                    </Text>

                    {
                        activityData['status'] == 'Ongoing' ?
                            <View>

                                <View style={{ height: 1, backgroundColor: Colors.grey.divider, marginTop: 14, marginBottom: 16 }} />

                                <Text style={[TextStyle.text14, { textAlign: "center", marginBottom: 16 }]}>
                                    {activityData['title']} <Text style={TextStyle.text14xb}>
                                        {getConsultationCallTime(activityData['callExpectedBy'])}</Text></Text>

                            </View> :
                            activityData['status'] == 'Consulted' ?
                                <View>
                                    <Pressable onPress={() => { CommonUtils.downloadPrescription(activityData['id'], activityData['serviceName']) }}
                                        style={{
                                            backgroundColor: Colors.primary, paddingVertical: 8, borderRadius: 20,
                                            marginTop: 14, marginBottom: 16, alignItems: "center"
                                        }}>

                                        <Text style={[TextStyle.text12xb, { color: activityData['statusColor'] }]}>
                                            {activityData['title']}</Text>
                                    </Pressable>
                                </View> :
                                <View>

                                    <View style={{ height: 1, backgroundColor: Colors.grey.divider, marginTop: 14, marginBottom: 16 }} />

                                    <View style={[AppStyles.flexRowSpaceBetween, { marginBottom: 16 }]}>
                                        <Text style={[TextStyle.text14xb, { color: activityData['statusColor'] }]}>
                                            {activityData['title']}</Text>
                                        {CommonRightChevronIcon('black')}
                                    </View>

                                </View>
                    }</View> : activityData['acType'] == ActivityType.order &&
                        activityData['isActiveOrder'] ?
                    <View style={[AppStyles.mediumShadow, {
                        marginRight: 8, marginTop: 16, marginBottom: 4,
                        width: activityListData?.length === 1 ? AppTheme.appWidth - 32 : 305, borderRadius: 12, backgroundColor: 'white'
                    }]}>

                        <View style={[AppStyles.flexRowStart,
                        { paddingHorizontal: 16, marginTop: 12 }]}>
                            <Image source={{
                                uri: CommonUtils.getImagePath(activityData['statusIcon'] ?? ''),
                                width: 32, height: 32
                            }} />
                            <Text style={[TextStyle.text14b,
                            {
                                color: activityData['statusColor'],
                                marginLeft: 12
                            }]}>
                                {activityData['title']}</Text>
                        </View>

                        <View style={{
                            height: 1, backgroundColor: Colors.grey.divider,
                            marginTop: 11, marginBottom: 12,
                            marginHorizontal: 16
                        }} />

                        <View style={[AppStyles.flexRowSpaceBetween, { paddingLeft: 16 }]}>

                            <View style={{ alignItems: "flex-start", marginBottom: 14 }}>
                                <Text style={[TextStyle.text14b,
                                { color: Colors.black }]}>
                                    Order #{activityData['oid']}</Text>

                                <Text style={[TextStyle.text12, { color: Colors.grey.dateTime, marginTop: 8 }]}>
                                    {getCommonDateTime(activityData['ts'])}</Text>
                            </View>

                            {activityData['pharmacyData'] &&
                                activityData['pharmacyData']['unreadMsgCount'] ?
                                <Pressable onPress={() => { openMessageView(props, activityData) }}
                                    style={[AppStyles.flexRow, {
                                        paddingHorizontal: 14, paddingTop: 12, paddingBottom: 10, backgroundColor: Colors.blue.cta,
                                        borderTopLeftRadius: 12, borderBottomRightRadius: 12, alignSelf: "flex-end"
                                    }]}>

                                    <Text style={[TextStyle.text14xb, { color: 'white', marginRight: 6 }]}>
                                        {activityData['pharmacyData']['unreadMsgCount']} Message{activityData['pharmacyData']['unreadMsgCount'] == 1 ? '' : 's'}</Text>
                                    {CommonRightChevronIcon('white')}
                                </Pressable> : <Pressable onPress={() => { props.navigation.replace(ScreenRoute.orders) }}
                                    style={[AppStyles.flexRow, {
                                        paddingHorizontal: 14, paddingTop: 12, paddingBottom: 10, backgroundColor: '#ECF1F8',
                                        borderTopLeftRadius: 12, borderBottomRightRadius: 12, alignSelf: "flex-end"
                                    }]}>

                                    <Text style={[TextStyle.text14xb, { color: Colors.blue.cta, marginRight: 6 }]}>
                                        Track Order</Text>
                                    {CommonRightChevronIcon('blue')}
                                </Pressable>}

                        </View>

                    </View> : null}
    </TouchableOpacity>
}

export const UserViewDesign = (props) => {
    return <View style={[AppStyles.flexRow,
    AppStyles.p16,
    AppStyles.mediumShadow,
    {
        marginHorizontal: 16,
        borderRadius: 4
    }]}>
        <View>
            <Avatar source={{
                uri: CommonUtils.getMemberImageURL(
                    props.consultationData['userId'])
            }}
                size={50} avatarStyle={{ borderRadius: 40 }} />
        </View>
        <View style={{ marginLeft: 24 }}>
            <Text numberOfLines={1} style={[TextStyle.text14,
            { width: AppTheme.appWidth - 135 }]}>
                {props.consultationData['userName']}</Text>
            <Text style={[AppStyles.f14,
            {
                color: Colors.green.primary,
                paddingVertical: 6
            }]}>
                {props.consultationData['categoryRM']['en']}</Text>
            <Text style={[TextStyle.text12, {
                color: Colors.grey.text
            }]}>{getCommonDateTime(props.consultationData['createdOn'])}</Text>
        </View>
    </View>
}

export const DoctorViewDesign = (props) => {
    return <View style={{ marginTop: 16 }}>
        <Pressable onPress={() => { props.setDoctorPopup({ active: true }) }}
            style={[AppStyles.flexRow,
            AppStyles.mediumShadow, {
                paddingVertical: 16, paddingHorizontal: 16,
                marginVertical: 8, marginHorizontal: 16, borderRadius: 4
            }]}>
                <Avatar source={{
                uri: props.consultationData.doctorProfile.profilePicURL ??
                    CommonUtils.getImagePath('/images/doctorProfile.png')
            }}
                size={50} avatarStyle={{ borderRadius: 40, paddingVertical: 19 }} />
            <View style={{ marginLeft: 24 }}>
                <Text style={[AppStyles.f16, { fontWeight: '500', paddingBottom: 4, color: Colors.black }]}>
                    Dr. {props.consultationData.doctorName}</Text>
                <Text style={[AppStyles.f12, {
                    color: Colors.black,
                    width: AppTheme.appWidth - 64 - 50 - 24
                }]}>{props.consultationData.doctorProfile.specialization} | Experience: {props.consultationData.doctorProfile.experience} years</Text></View>
        </Pressable>
    </View>
}

export const PrescriptionViewDesign = (props) => {
    return <View style={[AppStyles.mediumShadow,
    {
        marginHorizontal: 16,
        marginTop: 16,
        padding: 16,
        borderRadius: 8
    }]}>
        <Text style={[AppStyles.f16]}>Your Prescription</Text>
        <Text style={[AppStyles.f12, { marginTop: 8, color: Colors.grey.text }]}>
            {getCommonDateTime(props.consultationData['createdOn'])}</Text>
        <Pressable onPress={() => { CommonUtils.downloadPrescription(props.consultationData['id'], props.consultationData['serviceName']) }}
            style={[AppStyles.flexRowCenter, {
                marginTop: 16, marginBottom: 8, paddingHorizontal: 12, paddingVertical: 8, borderRadius: 4,
                justifyContent: "space-between", backgroundColor: Colors.purple.lightBg
            }]} onLongPress={() => { console.log('### long press') }}>
            <View style={[AppStyles.flexRowCenter,]}><Image source={{
                uri: CommonUtils.getImagePath('/images/erx_icon.png'),
                width: 44, height: 44
            }} />
                <Text style={[AppStyles.f16, { marginLeft: 16 }]}>View Prescription</Text></View>
            <MaterialIcons name="arrow-forward-ios" />
        </Pressable>
        <View style={{ height: 0.5, width: AppTheme.appWidth - 64, marginBottom: 16, backgroundColor: '#c4c4c4' }} />
        <Pressable onPress={() => { CommonUtils.downloadPrescription(props.consultationData['id'], props.consultationData['serviceName']) }}
            style={[AppStyles.flexRowCenter, {
                width: AppTheme.appWidth - 64, alignContent: "center`", justifyContent: "center", paddingVertical: 8,
                borderRadius: 20, borderWidth: 1.5, borderColor: Colors.primary
            }]} onLongPress={() => { console.log('### long press') }}>
            <Image source={{
                uri: CommonUtils.getImagePath('/images/icons/download_erx.svg'),
                width: 15, height: 20
            }} />
            <Text style={[AppStyles.f14, { fontWeight: '600', marginLeft: 10, color: Colors.primary }]}>Download</Text>
        </Pressable>
    </View>
}

export const VIPViewDesign = (props) => {
    return <View style={[AppStyles.mediumShadow, {
        marginHorizontal: 16, marginTop: 16,
        padding: 16, borderRadius: 8
    }]}><Text style={[TextStyle.text16, { marginBottom: 8 }]}>
            Dr. {props.consultationData['doctorName']} wants you to visit hospital</Text>
        <Text style={[TextStyle.text14, {
            color: Colors.primary, marginBottom: 4
        }]}>Reason for visit</Text>
        <Text style={[TextStyle.text14xb]}>
            {props.consultationData['vipData'].reasonEn}
        </Text>
    </View>
}

export const RefundedViewDesign = (props) => {
    return <View style={[AppStyles.mediumShadow,
    {
        marginHorizontal: 16, marginTop: 16,
        padding: 16, borderRadius: 8
    }]}>
        <Text style={[AppStyles.f16]}>Your Prescription</Text>
        <Text style={{ fontSize: 12, marginTop: 8, color: Colors.grey.text }}>
            {getCommonDateTime(props.consultationData['createdOn'])}</Text>
        <View style={{
            marginTop: 16, marginBottom: 8, paddingVertical: 12, paddingHorizontal: 16, borderRadius: 4,
            justifyContent: "center", backgroundColor: Colors.purple.lightBg
        }}>
            <Text style={{ fontSize: 16 }}>
                Full payment has been refunded to your wallet.</Text>
        </View>
    </View>
}

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    consultStatusLbl: { fontSize: 12, lineHeight: 20, padding: 4, marginTop: 6 },
    consultDate: {
        fontSize: 12,
        lineHeight: 20,
        color: '#4c4c4c'
    },
    drDegree: {
        fontSize: 12,
        lineHeight: 16,
        color: '#4c4c4c'
    },

    consultStatus: {
        flex: 1,
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: 'flex-start',
        marginTop: 16
    },
    consultFor: {
        fontSize: 14,
        lineHeight: 20,
        color: '#4c4c4c',
    },
    drName: {
        fontSize: 14,
        lineHeight: 20,
        color: '#666666',
        fontWeight: '600'
    },
    recentConsultation: {
        marginVertical: 9,
        marginHorizontal: 15,
        padding: 15,
        borderRadius: 8,
        backgroundColor: '#fff',
        shadowColor: AppTheme.color.black,
        zIndex: 1, shadowOpacity: 0.2, shadowRadius: 3, shadowOffset: {
            height: 1,
            width: 0.5
        },
        elevation: 5
    },
}))
